import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safe'
})
export class SafePipe implements PipeTransform {

  constructor(protected sanitizer: DomSanitizer) {}

  public transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
      switch (type) {
        case 'html': {
          if (value && value.includes('font-family:')) {
            const valueSplitsFontFamily = value.split('font-family:');
            for (let i = 1; i < valueSplitsFontFamily.length; i++) {
              valueSplitsFontFamily[i] = valueSplitsFontFamily[i].substring(valueSplitsFontFamily[i].indexOf(';') + 1);
            }
            value = valueSplitsFontFamily.join('');
          }
          return this.sanitizer.bypassSecurityTrustHtml(value || '');
        }
        case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
        case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
        case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
        case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
        default: throw new Error(`Invalid safe type specified: ${type}`);
      }
    }
}
